import { EcEnv } from './ec-env';

export const X_CHANNEL = 'X-Channel';
export const WEB_CHANNEL = 'web';
export const POS_CHANNEL = 'pos';
export const INTL_LOCALE = EcEnv.NEXT_PUBLIC_LOCALE;
export const INTL_CURRENCY = EcEnv.NEXT_PUBLIC_CURRENCY;
export const X_ACCESS_TOKEN = 'X-Access-Token';
export const CUSTOMER_DEFAULT_FIRSTNAME = 'Castlery';
export const CUSTOMER_DEFAULT_LASTNAME = 'Customer';

export const accessInSG = EcEnv.NEXT_PUBLIC_COUNTRY === 'SG';
export const accessInUS = EcEnv.NEXT_PUBLIC_COUNTRY === 'US';
export const accessInAU = EcEnv.NEXT_PUBLIC_COUNTRY === 'AU';
export const accessInCA = EcEnv.NEXT_PUBLIC_COUNTRY === 'CA';
export const accessInUK = EcEnv.NEXT_PUBLIC_COUNTRY === 'UK';
export const accessInSgAndAu = ['SG', 'AU'].includes(EcEnv.NEXT_PUBLIC_COUNTRY);
export const accessInSgAndAuAndCA = ['SG', 'AU', 'CA'].includes(EcEnv.NEXT_PUBLIC_COUNTRY);
export const accessInSgAndUS = ['SG', 'US'].includes(EcEnv.NEXT_PUBLIC_COUNTRY);
export const accessInAuAndUS = ['US', 'AU'].includes(EcEnv.NEXT_PUBLIC_COUNTRY);
export const accessInUSAndCA = ['US', 'CA'].includes(EcEnv.NEXT_PUBLIC_COUNTRY);
export const accessExcludeSG = EcEnv.NEXT_PUBLIC_COUNTRY !== 'SG';

export const accessInServer = EcEnv.NEXT_PUBLIC_IS_SERVER;
export const CATEGORY_MIDDLEWARE_REWRITE_PATHNAME = 'category-rewrite-pathname';

export const CountryMapping = {
  SG: 'Singapore',
  US: 'United States',
  AU: 'Australia',
  CA: 'Canada',
  UK: 'United Kingdom',
};

export const DY_CLIENT_BASE_URL = 'https://direct.dy-api.com/v2/';
export const DY_SERVER_BASE_URL = 'https://dy-api.com/v2/';

// server side 通过process.env获取环境变量
export const ONEPIECE_HOST = process.env['NEXT_PUBLIC_ONEPIECE_HOST'];

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const subscribeMap = new Map([
  ['SG', true],
  ['AU', true],
  ['US', true],
  ['CA', false],
  ['UK', false],
]);

export const countrySubscribeInitialStatus = subscribeMap.get(EcEnv.NEXT_PUBLIC_COUNTRY);
